import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate, useParams } from "react-router-dom";
import { useGetFarmerByIdQuery } from "./farmerApiSlice";
import { useEffect, useState } from "react";
import FarmerDetailsBasic from "./FarmerDetailsBasic";
import FarmerDetailsBank from "./FarmerDetailsBank";
import FarmerDetailsFamily from "./FarmerDetailsFamily";
import FarmerDetailsLiability from "./farmerDetailsLiability";
import FarmerDetailsAssets from "./FarmerDetailsAssets";
import FarmerDetailsLand from "./FarmerDetailsLand";
import FarmerDetailsResidential from "./FarmerDetailsResidential";
import FarmerDocuments from "./FarmerDocuments";
import { setBreadcrumbs } from "app/appSlice";
import { useDispatch } from "react-redux";
import SummaryFarmerOnboarding from "./SummaryFarmerOnboarding";
import FarmerDetailsCattle from "./FarmerDetailsCattle";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "features/auth/authSlice";
import HclDashNav from "components/HclDashNav";
import { TabPanel } from "features/Procurement/common/TabPanel";
import GovernNav from "components/Government/GovernNav";
import HclDashNav2 from "components/HclDashNav2";

const NewDetailViewFramer = () => {
  const { id } = useParams();
  const Navigate = useNavigate();
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles;
  const { data, isLoading, isFetching, refetch } = useGetFarmerByIdQuery(id, {
    refetchOnMountOrArgChange: "always",
    keepUnusedDataFor: 0,
  });

  const pathName = window.location.pathname.split("/");
  const moduleName = pathName[pathName.length - 1];
  const moduleNameFromgPath =
    moduleName.charAt(0).toUpperCase() + moduleName.slice(1);

  const dispatch = useDispatch();
  useEffect(() => {
    const breadcrumbs = [
      { name: "Dashboard", link: "/dashboard" },
      { name: "Farmers", link: "/onboarding/farmers" },
      { name: "Detail View" },
    ];
    dispatch(setBreadcrumbs(breadcrumbs));
  }, []);
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleActiveCard = (cardName) => {
    Navigate(cardName);
  };
  useEffect(() => {
    refetch();
  }, [id, refetch]);
  return (
    <div
      className="p-lg-0 p-md-0 p-2"
      style={{ padding: "30px"  }}
    >
    
      {/* {RoleAcessParams.includes("HCL") ? <HclDashNav />: ""} */}
      { <HclDashNav2 /> }

      <div
        className={ "container-fluid" }
        style={{
          paddingLeft:  "6rem" ,
          paddingRight:  "6rem" ,
        }}
      >
        <div
          className="p-1 p-lg-3 mt-2 transparent_card "
          style={{
            // backgroundColor: RoleAcessParams.includes("HCL") ? "#f5f7fa" : "" ,
            padding:  "10px",
          }}
        >
          {/* <div className="d-flex justify-content-between mt-1 right-border-shadow headerStyleCard"> */}
          <div className="d-flex justify-content-between mt-1 right-border-shadow">
            <div
              className="tabs-container"
              style={{ overflowX: "auto", whiteSpace: "nowrap" }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                // className="custom-tabs"
                indicatorColor="primary"
                // textColor="inherit"
                variant="scrollable"
              >
                <Tab label="Summary" className="f14" />
                <Tab label="Personal" className="f14" />
                {/* <Tab label="Residential" className="f14" /> */}
                <Tab label="Bank" className="f14" />
                <Tab label="Family" className="f14" />
                <Tab label="Liability" className="f14" />
                <Tab label="Assets" className="f14" />
                <Tab label="Cattle" className="f14" />

                <Tab label="Farm" className="f14" />
                <Tab label="Documents" className="f14" />
              </Tabs>
            </div>
          </div>
          <TabPanel value={value} index={0}>
            <div className="mt-2">
              <SummaryFarmerOnboarding
                data={data}
                refetch={refetch}
                isLoading={isLoading}
                applicationTabValue="0"
                RoleAcessParams={RoleAcessParams}
              />
            </div>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <FarmerDetailsBasic
              data={data}
              refetch={refetch}
              isLoading={isLoading}
            />
            <div className="mt-2">
              <FarmerDetailsResidential />
            </div>
          </TabPanel>
          {/* <TabPanel value={value} index={2}>
          <FarmerDetailsResidential />
        </TabPanel> */}
          <TabPanel value={value} index={2}>
            <FarmerDetailsBank tabIndex={value} />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <FarmerDetailsFamily />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <FarmerDetailsLiability />
          </TabPanel>
          <TabPanel value={value} index={5}>
            <FarmerDetailsAssets />
          </TabPanel>
          <TabPanel value={value} index={6}>
            <FarmerDetailsCattle DocData={data} />
          </TabPanel>
          <TabPanel value={value} index={7}>
            <FarmerDetailsLand
              tabIndex={value}
              data={data}
              refetch={refetch}
              isLoading={isLoading}
              RoleAcessParams={RoleAcessParams}
            />
          </TabPanel>
          <TabPanel value={value} index={8}>
            <FarmerDocuments tabIndex={value} data={data} refetch={refetch} />
          </TabPanel>
        </div>
      </div>
    </div>
  );
};

export default NewDetailViewFramer;
